import React from "react";
import { Button } from "primereact/button";

const MyButton1 = ({ title = "Button", method = () => {},marginLeft,marginBottom, fontSize = "14px",padding="",disabled = false, icon = null }) => {
  return (
     <button 
    onClick={method}
    disabled={disabled} 
  className="custom-buttom-home-button"
  style={{fontSize,padding,marginLeft,marginBottom}}
  >
    
      {title}
    </button>
  );
};

export default MyButton1;
